import { render, staticRenderFns } from "./Predictive.vue?vue&type=template&id=2c5a1035&scoped=true&"
import script from "./Predictive.vue?vue&type=script&lang=js&"
export * from "./Predictive.vue?vue&type=script&lang=js&"
import style0 from "./Predictive.vue?vue&type=style&index=0&id=2c5a1035&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a1035",
  null
  
)

export default component.exports